export enum ApprovalType {
  Manager = "Manager",
  SinglePerson = "Single Person",
  PoolName = "Pool Name",
}
export enum ManagerReferenceType {
  HiringManager = "hiring_manager",
  JobCreater = "job_creator",
  Recruiter = "recruiter",
}
export enum FallBackType {
  Admin = "admins",
  Pool = "pool",
}
